import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClientListCard = ({ assignment }) => {
  const navigate = useNavigate();
  const client = assignment?.client;

  return (
    <motion.div
      className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
      whileHover={{ y: -4 }}
    >
      <div className="flex items-start gap-4 mb-4">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-xl">
          {client?.fullName?.charAt(0)}
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-foreground text-lg">{client?.fullName}</h3>
          <p className="text-sm text-muted-foreground">{client?.email}</p>
          <span className="inline-block mt-2 text-xs px-2 py-1 rounded-full bg-green-100 text-green-600">
            Active
          </span>
        </div>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Calendar" size={16} />
          <span>Started: {format(new Date(assignment?.startDate), 'MMM dd, yyyy')}</span>
        </div>

        {client?.fitnessGoals && client?.fitnessGoals?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {client?.fitnessGoals?.map((goal, idx) => (
              <span key={idx} className="text-xs px-2 py-1 bg-muted rounded-full text-muted-foreground">
                {goal}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="outline"
          fullWidth
          onClick={() => navigate('/communication')}
        >
          <Icon name="MessageSquare" size={16} className="mr-2" />
          Message
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={() => navigate('/progress-reports')}
        >
          <Icon name="TrendingUp" size={16} />
        </Button>
      </div>
    </motion.div>
  );
};

export default ClientListCard;